import { useSelector } from "react-redux";
import { FormattedMessage } from 'react-intl';
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../../../hooks/hooks";
import { selectCurrent } from "../../../../../redux/settings/selectors";
import { selectListItems } from "../../../../../redux/library/selector";
import PageLoader from "../../../../../components/PageLoader";
import Table from "../../../../../common/components/table";
import { library } from "../../../../../redux/library/action";



const Library = () => {
	const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [pageData, setPageData] = useState(1)
	const result = useSelector(selectCurrent)
	const { header, footer, currency } = result
    const libraryItems = useSelector(selectListItems)
    const [rowData, setRowData] = useState([]);
    const [
        columnDefs,
        setColumnDefs
      ] = useState({});
      const [
        subColumnDefs,
        setSubColumnDefs
      ] = useState({});
      const createColumnDefs: any = () => {
        setColumnDefs([
          {
            field: 'Sl',
            sortable: false,
            filter: false,
            isSortLabel: true,
            headerName: 'Sl',
            cellRenderer (params: any) {
              return parseInt(
                params.node.id,
                10
              ) + 1;
            },
          },
          { field: 'library', headerName: 'Library Name' },
      { field: 'ViewMoreDetails', headerName: 'ViewMore Details', isExpanded: true }
      
        ]);
        setSubColumnDefs([
          {
            field: 'Sl',
            sortable: false,
            filter: false,
            headerName: 'Sl',
            isSortLabel:false,
            cellRenderer (params: any) {
              return parseInt(
                params.node.id,
                10
              ) + 1;
            },
          },
          { field: 'Text', headerName: 'Text' },
          { field: 'Description', headerName: 'Description' },
          { field: 'Disabled', headerName: 'Disabled', cellRenderer: 'yesNoRenderer' },
          { field: 'Selected', headerName: 'Selected', cellRenderer: 'yesNoRenderer' },
          { field: 'Value', headerName: 'Value' }
        ]);
      }
      const fetchLibraries=()=>{

        dispatch(library.read({
          url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/library/query-by-list`,
          entity: 'library',
          jsonData: { "PageNumber": pageData,
          "PageSize": 10,
          "SortField": "Id",
          "SortOrder": "desc",}
      }));
       
      }
	useEffect(() => {
        createColumnDefs()
        fetchLibraries()
	}, [pageData])

  useEffect(() => {
    if (libraryItems?.result) {
      const fieldDefinitions: any = Object.keys(libraryItems.result).map((name, index) => ({
        Id: index + 1,
        library: name,
        value: libraryItems.result[name],
      }));
      setRowData(fieldDefinitions);
    }
  }, [libraryItems]);

 
	return (
    <>
    {libraryItems?.isLoading ? 
    <PageLoader />
: 
		<Table subColumnDefs={subColumnDefs} columnData={columnDefs} rowData={rowData} setPageData={setPageData}
    headingName="Library"  />
      
  }
  </> 
	);
  
};

export default Library;


